import type { NextRouter } from "next/router"
import { useContext } from "react"

import { RoutingContainer } from "@/lib/routing/container"
import { RoutingContext } from "@/lib/routing/context"

export namespace Routing {
  export type ContextData = NextRouter

  export const Container = RoutingContainer
  export const Context = RoutingContext

  export const useRouter = () => {
    return useContext(RoutingContext)
  }

  export type ParsedUrlQueryValue = string | string[] | undefined

  export namespace Functions {
    export type IsParamValid<ExpectedType extends ParsedUrlQueryValue> = (
      param: ParsedUrlQueryValue
    ) => param is ExpectedType
  }
}
